import { render, staticRenderFns } from "./activityTypes.vue?vue&type=template&id=33ddddbe"
import script from "./activityTypes.vue?vue&type=script&lang=js"
export * from "./activityTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports